export const SUPPORT_EMAIL = "customersuccess@jemhr.com";
